import { RequestCheckpoint } from '../Models/checkpoint';
import { findMaxDownloadSpeed, findAverageDownloadSpeed, summarizeDownloadSpeed } from './request-helpers';
import { startNextServerTest } from '../index';
import { ViewManager } from './view-manager';

let 
    currentHost,
    finishedRequests,
    downloadSpeedCheckpoints,
    doCheckpoint,
    pingDownloadSpeedArray,
    viewManager;

const getUrl = () => {
    const 
        randomNumber = Math.random(),
        currentHostUrl = currentHost.hostUrl,
        currentHostPort = currentHost.hostPort;

    let url = `${currentHostUrl}:${currentHostPort}/garbage.php?r=${randomNumber}&ckSize=100`;
    return url;
}

const setCheckpoint = (event) => {
    doCheckpoint = false;
    setTimeout(() => doCheckpoint = true, 250);

    const checkpoint = new RequestCheckpoint(event.loaded, event.timeStamp);

    if (downloadSpeedCheckpoints.length == undefined) {
        downloadSpeedCheckpoints = [];
        downloadSpeedCheckpoints.push(checkpoint);
    }
    else {
        downloadSpeedCheckpoints.push(checkpoint);
    }
}

const downloadRequest = (pingsPerAction, timePerTestedServer, hostName, pingIndex) => {
    const xml = new XMLHttpRequest();

    xml.onprogress = (event) => {
        if (xml.readyState == 3) {
            if (doCheckpoint == true) {
                setCheckpoint(event);
                viewManager.updateTable(hostName, pingIndex, findAverageDownloadSpeed(downloadSpeedCheckpoints), findMaxDownloadSpeed(downloadSpeedCheckpoints))
            }
        }
    }

    xml.onreadystatechange = (event) => {
        if (xml.readyState == 2) {
            setTimeout(() => xml.abort(), timePerTestedServer)

            viewManager.updateServerRequestStatus(hostName, pingIndex, 'In Progress');
        }

        if (xml.readyState == 4) {
             afterHandler(event, pingsPerAction, pingIndex);
        }
    }

    xml.onerror = (event) => {
        viewManager.updateServerRequestStatus(hostName, pingIndex, 'Server is Off');
        viewManager.updateTable(hostName, pingIndex, 0, 0);
    }

    xml.open('GET',getUrl(),true);
    xml.send();    
}

const afterHandler = (event, pingsPerAction, pingIndex) => {
    const 
        downloadTimeInSecs =  event.timeStamp / 1000, // from milliseconds to seconds
        downloadedDataSizeInMb = event.loaded * 8 / 1048576; // from bytes to mb

    finishedRequests++;
    pingDownloadSpeedArray.push(downloadedDataSizeInMb / downloadTimeInSecs);
    
    if (finishedRequests == pingsPerAction) {
        summarizeDownloadSpeed(pingDownloadSpeedArray, pingIndex, currentHost ,viewManager, downloadSpeedCheckpoints);

        startNextServerTest();
    }
}

export class RequestManager {
    constructor() {
    }

    getUserCountry() {
        return new Promise((resolve, reject) => {
            const xml = new XMLHttpRequest();

            xml.onreadystatechange = (event) => { 
                if (xml.readyState == 4) {
                    if (xml.status == 200) {
                        resolve(xml.response);
                    }
                    else {
                        reject(xml.statusText);
                    }
                }
            }

            xml.open("GET", "https://ip2loc.patchkit.net/v1/country", true);
            xml.send(); 
        }) 
    }

    requestManager(hostToCheck, pingsPerAction, timePerTestedServer) {
        currentHost = hostToCheck;
        finishedRequests = 0;
        doCheckpoint = true;
        downloadSpeedCheckpoints = [];
        pingDownloadSpeedArray = [];

        viewManager = new ViewManager();
        viewManager.initTables();

        for (var i = 0; i < pingsPerAction; i++) {
            downloadRequest(pingsPerAction, timePerTestedServer, hostToCheck.hostName, i+1);
        } //sending few requests at once
    }
}